// extracted by mini-css-extract-plugin
module.exports = {"container":"page-module--container--2FMpq","subContainer":"page-module--subContainer--1zyuh","title":"page-module--title--2dbCf"};